import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../app/ReduxStore.ts'

export interface PageTitle {
  title: string
}

const initialState: PageTitle = {
  title: '',
}

export const pageTitleSlice = createSlice({
  name: 'pageTitle',
  initialState,
  reducers: {
    setPageTitle: (state, action) => {
      state.title = action.payload
    },
  },
})

export const pageTitle = (state: RootState) => state.pageTitle.title
export const { setPageTitle } = pageTitleSlice.actions

export default pageTitleSlice.reducer
